import {extractVimeoIdFromUrl, extractYoutubeIdFromUrl} from '~/features/portfolio/composable/useVideoInfos';

export const PortfolioHelper = {
    getVideoType(url: string): 'VIMEO' | 'YOUTUBE' | undefined {
        if (url.includes('vimeo')) {
            return 'VIMEO';
        }

        if (url.includes('youtube') || url.includes('youtu.be')) {
            return 'YOUTUBE';
        }
    },
    getEmbededVideoURL(url: string): string {
        switch (this.getVideoType(url)) {
            case 'VIMEO': {
                const {id, hash} = extractVimeoIdFromUrl(url);
                return `https://player.vimeo.com/video/${id}${hash ? `?h=${hash}` : ''}`;
            }
            case 'YOUTUBE':
                return 'https://youtube.com/embed/' + extractYoutubeIdFromUrl(url);
            default:
                return url;
        }
    },
};
